import React, {useEffect, useState} from 'react';
import {Row} from 'react-bootstrap';
import {Link, withRouter} from 'react-router-dom'
import {fetch_owned_designs} from '../Dashboard/actions';
import PlaceHolder from '../../components/placeholder';
import {useSelector} from "react-redux";
// import {connect} from 'react-redux';
import MockupEditor from "../MockupEditor";
import PenguinSlider from "../../components/PenguinSlider";
import ImageBox from "../../components/ImageBox";
import {Fetch} from '../../utils';
import {use_deep_compare} from '../../hooks/deep_compare';

import './style.css';

const { feline_fetch } = Fetch;


const Recommendations_Panel = ({ recommendation_category }) => {
    try {
        //state
        const [ show_panel, set_show_panel ] = useState(false);
        const [ mockups, set_mockups ] = useState([]);

        //effects
        useEffect(() => {
            // console.log('reco --> ', recommendation_category);
            if (recommendation_category && recommendation_category.mockups && recommendation_category.mockups.length) {
                // console.log('saved mockups received')
                set_mockups(recommendation_category.mockups);
                set_show_panel(true);
            }
        }, [ recommendation_category ])


        use_deep_compare(() => {
            if (mockups && mockups.length) {
                set_mockups(mockups.map(mockup => {
                    var images;
                    if (mockup.placeholders && mockup.placeholders.length) {
                        images = mockup.placeholders.map(o => (o.indexOf('data:image')>-1 || o.indexOf('http')>-1 || o.indexOf('blob:')>-1)?o:global.config.static_file_server_path+o)
                    } else {
                        images = [global.config.static_file_server_path+mockup.tracing_image_src]
                    }
                    return { ...mockup, images };
                }));
            }
        }, [ mockups ])

        //render
        return (
            show_panel ? (
                <>
                    <Row style={{marginTop: 25, marginBottom: 20}}>
                        <span style={{fontSize: 20, fontFamily: 'Montserrat', fontWeight: 800}}>Try your design on other mockups</span>
                    </Row>
                    <PenguinSlider id="recommendation_slider" height={200} >
                        {mockups && mockups.length && mockups.map((mockup, idx) => (
                            <div style={{ marginRight: 20, height: 200, maxWidth: 200, display: 'inline-block' }}>
                                <Link style={{cursor:"pointer"}} to={"/mockupmaker/start/mockups/" + mockup._id}>
                                    <PlaceHolder 
                                        height={200} 
                                        extra_styles={{ height: 'auto', maxHeight: 200, minWidth: '100%', objectFit: 'contain', boxShadow: '0 5px 20px 0 rgba(0,0,0,0.1)' }} 
                                        mockup={mockup} 
                                        images={mockup.images ? [ ...mockup.images ] : []}
                                    />
                                </Link>
                            </div>
                        ))}                             
                    </PenguinSlider>
                </>
            ) : ''
        );
    } catch(err) {
        console.log('error in Recommendations --> ', err);
        return '';
    }
}


const Saved_Mockups_Panel = ({ saved_mockups }) => {
    try {

        //state
        const [ show_panel, set_show_panel ] = useState(false);

        //effects
        useEffect(() => {
            if (saved_mockups && saved_mockups.length) {
                // console.log('saved mockups received')
                set_show_panel(true);
            }
        }, [ saved_mockups ])

        //render
        return (
            show_panel ? (
                <>
                    <Row style={{marginTop: 20, marginBottom: 20}}>
                        <span style={{fontSize: 20, fontFamily: 'Montserrat', fontWeight: 800}}>Your saved mockups</span>
                    </Row>
                    <PenguinSlider id="saved_mockup_slider" height={200} >
                        {saved_mockups.map((saved_mockup, idx) => (
                            <Link style={{ cursor:"pointer" }} to={"/mockupmaker/start/saved_mockups/" + saved_mockup._id}>
                                <ImageBox 
                                    key={'saved_mockup_box_' + idx}
                                    on_click={ () => console.log('hello') }
                                    idx={idx}
                                    image_src={global.config.static_file_server_path + saved_mockup.watermarked_output_src}
                                    name={saved_mockup.mockup.name}
                                    image_style={{ height: 200 }}
                                    disable_overlay={true}
                                />
                            </Link>
                        ))}                             
                    </PenguinSlider>
                </>
            ) : ''
        );
    } catch(err) {
        console.log('error in saved mockup panel --> ', err);
        return '';
    }
}


const Mockup_Page = ({ match }) => {
    try {

        //css 
        const container_style = {
            width: '100%',
            paddingTop: 40, 
            backgroundColor: 'white',
            paddingLeft: 190,
            paddingRight: 190
        }

        const panel_style = {
            width: '100%',
            paddingTop: 0, 
            backgroundColor: 'white',
            paddingLeft: 190,
            paddingRight: 190
        }

        const container_style_tablet = {
            ...container_style,
            paddingRight: 10,
            paddingLeft: 10
        }

        //state variables
        const [ mockup, set_mockup ] = useState(null);
        const [ saved_mockup, set_saved_mockup ] = useState(null);
        const [ mockup_id, set_mockup_id ] = useState(null);
        const [ saved_mockup_id, set_saved_mockup_id ] = useState(null);
        const [ all_saved_mockups, set_all_saved_mockups ] = useState([]);
        const [ mockup_price, set_mockup_price ] = useState(null);
        const [ recommendation_category, set_recommendation_category ] = useState(null);
        const [ device_type, set_device_type ] = useState('desktop');


        //redux
        const user = useSelector(state => state.user);


        //memeber functions
        const fetch_recommendations = async category_id => {
            try {
                var url = 'category/get_recommendations';
                var body = {id: category_id};
                var category = await feline_fetch({ url, body })
                set_recommendation_category(category);
            } catch(err) {
                console.log(err)
            }
        }

        const fetch_mockup_data = async () => {
            try {
                var url = 'mockup/get_one';
                var body = { id : mockup_id };
                var data = await feline_fetch({ url, body })
                set_mockup(data);
                set_mockup_price(data.price);
            } catch(err) {
                console.log(err)
            }
        }

        const fetch_saved_mockup_data = async () => {
            try {
                var url = 'mockup/get_saved';
                var body = { _id : saved_mockup_id };
                var data = await feline_fetch({ url, body })
                set_mockup(data.mockup);
                set_mockup_price(data.mockup.price);
                delete data.mockup;
                set_saved_mockup(data);
            } catch(err) {
                console.log(err)
            }
        }

        const fetch_all_saved_mockups = async () => {
            try {
                var data = await feline_fetch({ url: 'mockup/get_all_saved', body: {} })
                console.log('saved mockups ===>> ', data);
                set_all_saved_mockups(data);
            } catch(err) {
                console.log(err)
            }
        }

        const update_window_size = () => {
            if (window.innerWidth > 991) {
                set_device_type('desktop');
            } else {
                set_device_type('tablet');
            }
        }

        const fetch_mockup_id = () => {
            try {
                if (match.params && match.params.mockup_id) {
                    set_mockup_id(match.params.mockup_id)
                }
                if (match.params && match.params.saved_mockup_id) {
                    set_saved_mockup_id(match.params.saved_mockup_id)
                }
            } catch(err) {
                console.log("error in url --> ", err);
            }
        }

        const initialize = () => {
            set_mockup_id(null);
            set_mockup(null);
            set_saved_mockup_id(null);
            set_saved_mockup(null);
            fetch_mockup_id();
            update_window_size();
            window.onresize = update_window_size;
        }

        const empty_function = () => {
            
        }

        //effects
        useEffect(() => {
            initialize()
        }, []);

        useEffect(() => {
            console.log('hide_image_options_modaloooøøøøøøøøøø')
            initialize();
        }, [ match ]);

        useEffect(() => {
            if (mockup_id) {
                fetch_mockup_data();
            } else if (saved_mockup_id) {
                fetch_saved_mockup_data();
            }
        }, [ mockup_id, saved_mockup_id ])

        useEffect(() => {
            if (mockup && mockup.categories && mockup.categories.length) {
                fetch_recommendations(mockup.categories[0]);
            }
        }, [ mockup ])

        use_deep_compare(() => {
            if (user) {
                console.log("user logged in ----> ", user);
                fetch_all_saved_mockups();
            }
        }, [ user ])


        //result
        return (
            <div style={{ paddingTop: 75 }}>
                <div id="container" style={device_type == 'desktop' ? container_style : container_style_tablet}>
                    <MockupEditor
                        mockup={mockup}
                        saved_mockup={saved_mockup}
                        device_type={device_type}
                        fetch_all_saved_mockups={fetch_all_saved_mockups}
                        user={user}
                        is_dm={false}
                        apply_mockup_editor={empty_function}
                    />
                </div>
                <div id="recommended_mockup_container" style={device_type == 'desktop' ? panel_style : container_style_tablet}>
                    <Recommendations_Panel
                        recommendation_category={recommendation_category}
                    />
                </div>
                <div id="saved_mockup_container" style={device_type == 'desktop' ? panel_style : container_style_tablet}>
                    <Saved_Mockups_Panel
                        saved_mockups={all_saved_mockups}
                    />
                </div>
                <Row style={{marginTop: 20, marginBottom: 20}}></Row>
            </div>
        );
    } catch(err) {
        return '';
    }
}


const mapStateToProps = function(state) {
    return {
        show_upload_mockup_modal: state.display_upload_mockup_modal,
        user: state.user
     }
}

const mapDispatchToProps = dispatch => {
    return {        
        fetch_owned_designs: () => dispatch(fetch_owned_designs())
    }
}

export default withRouter(Mockup_Page);

